import { z } from "zod";

const UpdateInsuranceArgsSchema = z.object({
  data: z.object({
    patient_id: z.number(),
    member_id: z.string(),
    insurance_company_id: z.number(),
    secondary_payer: z
      .object({
        member_id: z.string(),
        insurance_company_id: z.number(),
      })
      .nullable()
      .optional(),
  }),
});

export const UpdateInsuranceResponseSchema = z.object({
  supported: z.boolean(),
});

export type UpdateInsuranceArgs = z.infer<typeof UpdateInsuranceArgsSchema>;
export type UpdateInsuranceResponse = z.infer<typeof UpdateInsuranceResponseSchema>;
